import {FC} from 'react'
import {Link} from 'react-router-dom'
import {Hint} from 'jbc-front/components/presenters/ui/Hint'
import {useQuery} from 'hooks/graphql'
import {useSelector} from 'hooks/redux'
import {FlatCard, FlatCardBody, FlatCardHeader, FlatCardTitle} from '../FlatCard'
import {
  PROCEDURE_STATUS_SUMMARY,
  ProcedureStatusSummaryQueryVariables,
  ProcedureStatusSummaryQueryResult,
  ProcedureStatusSummary as ProcedureStatusSummaryEntry,
} from './query'
import styles from './ProcedureStatusSummary.scss'

const statusTypes = [
  {key: 'applying', label: '承認待ち'},
  {key: 'draft', label: '途中保存'},
  {key: 'in_progress', label: '対応中'},
  {key: 'request', label: '依頼中'},
  {key: 'done', label: '完了'},
]

export const ProcedureStatusSummary: FC = () => {
  const planType = useSelector((state) => state.client.current.plan_type)

  const {data} = useQuery<ProcedureStatusSummaryQueryResult, ProcedureStatusSummaryQueryVariables>(
    PROCEDURE_STATUS_SUMMARY,
    {
      fetchPolicy: 'network-only',
    }
  )
  const procedureStatusSummary = data?.client.procedureStatusSummary

  return (
    <FlatCard className={styles.procedureStatuses}>
      <FlatCardHeader border>
        <FlatCardTitle className={styles.cardTitle}>
          現在進行中の手続き
          {planType === 'free_plan' && (
            <Hint leftPoint={-10}>
              <p>
                無料プランは機能制限により手続き情報をご確認いただけない場合があります。
                <br />
                有料プランにお申し込みいただくことで、すべての手続きをご覧いただけるようになります。
              </p>
            </Hint>
          )}
        </FlatCardTitle>
      </FlatCardHeader>
      <FlatCardBody className={styles.cardBody}>
        {procedureStatusSummary && <SummaryDisplay summary={procedureStatusSummary} />}
      </FlatCardBody>
    </FlatCard>
  )
}

interface SummaryDisplayProps {
  summary: ProcedureStatusSummaryEntry[]
}

const SummaryDisplay: FC<SummaryDisplayProps> = ({summary}) => {
  const countByStatus = new Map<string, number>()
  for (const sum of summary) {
    countByStatus.set(sum.status, (countByStatus.get(sum.status) ?? 0) + sum.count)
  }

  return (
    <div className={styles.summaryDisplay}>
      {statusTypes.map(({key, label}) => {
        const count = countByStatus.get(key) ?? 0

        return (
          <div key={key} className={styles.summary}>
            <div className={styles.summaryLabel}>{label}</div>
            <div className={styles.summaryCountWrapper}>
              {count > 0 ? (
                <Link className={styles.summaryCountNum} to={`/procedure_statuses?procedure_type=all&status=${key}`}>
                  {count}
                </Link>
              ) : (
                <span className={styles.summaryCountNum}>0</span>
              )}
              <span className={styles.summaryCountUnit}>件</span>
            </div>
          </div>
        )
      })}
    </div>
  )
}
